import { render, staticRenderFns } from "./GExamCreateQuestionSettingDetail.vue?vue&type=template&id=1cb98412&scoped=true&"
import script from "./GExamCreateQuestionSettingDetail.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateQuestionSettingDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GExamCreateQuestionSettingDetail.vue?vue&type=style&index=0&id=1cb98412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb98412",
  null
  
)

export default component.exports